import React from "react";
import { motion } from "framer-motion";
import { ShieldCheckIcon, ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  sublabel?: string;
  arrow?: boolean;
};
export function CtaButton({
  label,
  id,
  sublabel,
  arrow = false
}: CtaButtonProps) {
  return <motion.a id={id} href={CHECKOUT_URL} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className="group mx-auto flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-white shadow-[0_10px_0_0_#11823B,0_18px_30px_-10px_rgba(22,163,74,0.6)] transition-colors duration-150 ease-out hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:px-8" data-id="element-98" data-mp="cjhlgix9m4pq">
      <ShieldCheckIcon className="h-7 w-7 shrink-0" aria-hidden="true" data-id="element-99" data-mp="19bbbfhphad7n" />
      <span className="flex flex-col" data-id="element-100" data-mp="15ahs71mzdml3">
        <span className="font-display text-[17px] font-extrabold uppercase leading-tight tracking-wide sm:text-xl" data-id="element-101" data-mp="157n4904rdjmx">
          {label}
        </span>
        {sublabel && <span className="mt-1 text-xs font-medium text-white/90 sm:text-sm" data-id="element-102" data-mp="39z9jeznrph32">{sublabel}</span>}
      </span>
      {arrow && <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-103" data-mp="3jwxg3v4xoynv" />}
    </motion.a>;
}